<script>
  import { useParams } from "svelte-navigator";
  export let userID = null;
</script>
<div>
  User Details {userID}
</div>
